module.exports = __webpack_public_path__ + "img/footer-1.a2947edf.gif";